module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./dt.js"));
	}, "DT");
}